import { createContext } from "react"

export const RedirectContext = createContext<{
	redirect: (url: string) => void
}>({
	redirect: () => {
		/* noop */
	},
})
